export enum Regions{
    IAD = "IAD",
    DUB = "DUB",
    PDX = "PDX",
    SIN = "SIN"
}

export const LATEST_CODE_VERSION = "Latest";

export enum ModelTrainingStep{
    PRE_TRAIN = "PRE_TRAIN",
    TRAIN = "TRAIN",
    POST_TRAIN = "POST_TRAIN"
}
